export const buttonTemplate = {
  '_template': 'button',
  'title': {
    es: 'Start',
    en: 'Start'
  },
  button: {
    size: 'large',
    type: 'primary',
    shape: false
  }
};
export const buttonsTemplate = {
  _template: 'buttons',
  blocks: [
    buttonTemplate,
    buttonTemplate,
  ],
  text: {
    align: {
      xl: 'left'
    }
  },
  box: {
    margin: {
      marginTop: {
        xl: 40
      }
    }
  },

};
